import styled, { css, keyframes } from 'styled-components';

const SCALE_SHORT = 12 / 18;

const oddKeyframes = keyframes`
  0%, 100% { transform: scaleY(1); }
  50%       { transform: scaleY(${SCALE_SHORT}); }
`;

const evenKeyframes = keyframes`
  0%, 100% { transform: scaleY(${SCALE_SHORT}); }
  50%       { transform: scaleY(1); }
`;

interface StripProps {
    $isOdd: boolean;
    $animated: boolean;
    $delay: number;
}

export const Strip = styled.div<StripProps>`
    width: 3px;
    height: 18px;
    transform: scaleY(${({ $isOdd }) => ($isOdd ? 1 : SCALE_SHORT)});
    border-radius: 1.5px;
    background-color: currentColor;
    ${({ $animated, $isOdd, $delay }) =>
        $animated &&
        css`
            animation: ${$isOdd ? oddKeyframes : evenKeyframes} 1s ${$delay}s ease-in-out infinite;
        `}
`;

interface WrapperProps {
    $color?: string;
}

export const Wrapper = styled.div<WrapperProps>`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    color: ${(props) => props.$color ?? props.theme.root.colors.primary.default};
`;
